import React, { useState } from "react";
import OnDutyForm from "./InjectionTabs/OnDutyForm";
import AssignedRnForm from "./InjectionTabs/AssignedRnForm";

const InjectionForm = ({ formData, handleChange }) => {
    const [activeTab, setActiveTab] = useState("onDuty");

    return (
        <div id="injection-form" className="content">
            <div className="row g-3 justify-content-center">
                {/* ================== STANDARD INFORMATION ================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Standard Operating Procedures
                    </small>
                </div>
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="standardName"
                            value={formData.standardName || ""}
                            onChange={handleChange}
                            placeholder="Standard Name"
                        />
                        <label>Standard Name</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="issueDate"
                            value={formData.issueDate || ""}
                            onChange={handleChange}
                        />
                        <label>Issue Date</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="reviewDate"
                            value={formData.reviewDate || ""}
                            onChange={handleChange}
                        />
                        <label>Review Date</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="documentNumber"
                            value={formData.documentNumber || ""}
                            onChange={handleChange}
                            placeholder="Document #"
                        />
                        <label>Document #</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="revisionNumber"
                            value={formData.revisionNumber || ""}
                            onChange={handleChange}
                            placeholder="Rev #"
                        />
                        <label>Rev #</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="departmentName"
                            value={formData.departmentName || ""}
                            onChange={handleChange}
                            placeholder="Department"
                        />
                        <label>Department</label>
                    </div>
                </div>
                {/* ================== PATIENT INFORMATION ================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Patient Information
                    </small>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="patientName"
                            value={formData.patientName || ""}
                            onChange={handleChange}
                            placeholder="Name"
                            readOnly={!!formData.patientId || !!formData.patient_id}
                        />
                        <label>Name</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            className="form-select"
                            name="patientGender"
                            value={formData.patientGender ? formData.patientGender.charAt(0).toUpperCase() + formData.patientGender.slice(1).toLowerCase() : ""}
                            onChange={handleChange}
                            disabled={!!formData.patientId || !!formData.patient_id}
                        >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>
                        <label>Gender</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="patientDOB"
                            value={formData.patientDOB || ""}
                            onChange={handleChange}
                            readOnly={!!formData.patientId || !!formData.patient_id}
                        />
                        <label>Date of Birth</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="patientContact"
                            value={formData.patientContact || ""}
                            onChange={handleChange}
                            placeholder="Contact"
                            readOnly={!!formData.patientId || !!formData.patient_id}
                        />
                        <label>Contact</label>
                    </div>
                </div>

                {/* ================= FINANCE INFORMATION ================= */}
                <div className="col-md-12 mt-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Finance Information
                    </small>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="amount"
                            value={formData.amount || ""}
                            onChange={handleChange}
                            placeholder="Amount"
                        />
                        <label>Amount</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            className="form-select"
                            name="paymentStatus"
                            value={formData.paymentStatus || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select Status</option>
                            <option value="Paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                        </select>
                        <label>Payment Status</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="referenceNo"
                            value={formData.referenceNo || ""}
                            onChange={handleChange}
                            placeholder="Reference No"
                        />
                        <label>Reference No</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="paymentDate"
                            value={formData.paymentDate || ""}
                            onChange={handleChange}
                        />
                        <label>Payment Date</label>
                    </div>
                </div>

                {/* ================== TABS ================== */}
                <div className="col-md-12 mt-4">
                    <div className="mb-4">
                        <div className="card-header pb-0 mb-4">
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "onDuty" ? "active" : ""}`}
                                        onClick={() => setActiveTab("onDuty")}
                                        role="tab"
                                        type="button"
                                    >
                                        <i className="ri-stethoscope-line me-1"></i>
                                        On-Duty Doctor / Consultant
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "rn" ? "active" : ""}`}
                                        onClick={() => setActiveTab("rn")}
                                        role="tab"
                                        type="button"
                                    >
                                        <i className="ri-nurse-line me-1"></i>
                                        Assigned RN / Dispenser
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="card-body">
                            {activeTab === "onDuty" ? (
                                <OnDutyForm formData={formData} handleChange={handleChange} />
                            ) : (
                                <AssignedRnForm formData={formData} handleChange={handleChange} />
                            )}
                        </div>
                    </div>
                    <style>{`
.nav-tabs .nav-link {
    transition: all 0.2s ease-in-out;
    border: none;
    background: transparent;
}

.nav-tabs .nav-link:hover {
    background-color: #e9ecef;
    border-color: transparent;
    transform: translateY(-1px);
}

.nav-tabs .nav-link.active {
    background-color: #007bff;
    color: white;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

`}</style>
                </div>
            </div>
        </div>
    );
};

export default InjectionForm;